var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ITMLayout',[_c('div',{directives:[{name:"horizontal-scroll",rawName:"v-horizontal-scroll"}],staticClass:"overflow-x"},[_c('FixedPlaceholder',{attrs:{"component":_vm.ITMHorizontalMenu,"tabs":_vm.tabs,"horizontal":""}}),_c('div',{staticClass:"p-5"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }